import { QuoteEntityType, QuoteType } from 'quotes/enums';
import { IBaseQuote } from 'quotes/types';

export const QuoteHelper = {
  determineType: (quote: IBaseQuote, currentCompanyId: number) => {
    const customerCompanyId = quote?.customerCompanyId;
    const vendorCompanyId = quote?.vendorCompanyId;

    if (currentCompanyId === customerCompanyId) {
      return QuoteType.VENDOR;
    }

    if (currentCompanyId === vendorCompanyId) {
      return QuoteType.CUSTOMER;
    }

    return null;
  },

  determineEntityType: (quote?: IBaseQuote) => {
    if (quote?.isOrder) {
      return QuoteEntityType.ORDER;
    }

    return QuoteEntityType.QUOTE;
  },
};
